import { useWizard } from '../../../context/WizardContext';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';
import type { QuestionVersion } from '../../../types/wizard';
import { cn } from '../../../lib/utils';
import { useTranslation } from '../../../context/LanguageContext';
import type { TranslationKey } from '../../../i18n';
import { Check } from 'lucide-react';

// These name the language of the *generated paper*, so each is written in the
// language it selects and stays legible whatever the interface language is.
const VERSIONS: {
  value: QuestionVersion;
  labelKey: TranslationKey;
  sublabelKey: TranslationKey;
  flag: string;
}[] = [
  {
    value: 'Bangla',
    labelKey: 'wizard.versionBangla',
    sublabelKey: 'wizard.versionBanglaSub',
    flag: '🇧🇩',
  },
  {
    value: 'English',
    labelKey: 'wizard.versionEnglish',
    sublabelKey: 'wizard.versionEnglishSub',
    flag: '🇬🇧',
  },
];

export function Step0Version() {
  const { state, setVersion } = useWizard();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">{t('wizard.versionTitle')}</h2>
        <p className="text-sm text-slate-500 mt-1">{t('wizard.versionSubtitle')}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {VERSIONS.map((v) => {
          const isSelected = state.selectedVersion === v.value;
          return (
            <button
              key={v.value}
              type="button"
              onClick={() => setVersion(v.value)}
              className={cn(
                'relative flex flex-col items-center gap-4 rounded-2xl border-2 p-8 transition-all duration-200 focus:outline-none group',
                isSelected
                  ? 'border-transparent bg-brand-50 ring-2 ring-brand-300 shadow-md'
                  : 'border-slate-700 bg-slate-700/50 hover:border-slate-600 hover:shadow-card-hover hover:-translate-y-0.5'
              )}
            >
              {isSelected && (
                <span className="absolute top-3 right-3 flex h-5 w-5 items-center justify-center rounded-full bg-brand-600 text-white">
                  <Check className="h-3 w-3" strokeWidth={3} />
                </span>
              )}
              <span className="text-5xl">{v.flag}</span>
              <div className="text-center">
                <p
                  className={cn('text-xl font-bold', isSelected ? 'text-violet-300' : 'text-white')}
                >
                  {t(v.labelKey)}
                </p>
                <p className="text-sm text-slate-500 mt-1">{t(v.sublabelKey)}</p>
              </div>
            </button>
          );
        })}
      </div>

      <NavigationButtons />
    </div>
  );
}
